





























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Game, CutinLog } from '@/class/game'
import { RoleId } from '@/enum'
import Cutin from '@/components/Utils/Cutin.vue'
import SelfProclaim from './SelfProclaim.vue'
import SelfProclaimNotice from './SelfProclaimNotice.vue'
import ProclaimPoliceResultMessage from '@/components/Game/Play/Log/ProclaimPoliceResultMessage.vue'
import ProclaimInvestigatorResultMessage from '@/components/Game/Play/Log/ProclaimInvestigatorResultMessage.vue'

@Component({
  components: {
    Cutin,
    SelfProclaim,
    SelfProclaimNotice,
    ProclaimPoliceResultMessage,
    ProclaimInvestigatorResultMessage
  }
})
export default class GameLogCutIn extends Vue {
  @Prop() game!: Game
  @Prop() playerSelfRoleId?: RoleId

  shows = true

  async next() {
    this.shows = false

    if (this.game.cutinLogs.length === 0) {
      return
    }

    this.game.cutinLogs.shift()

    await this.$nextTick()

    this.shows = true
  }

  get log() {
    return this.game.cutinLogs[0]
  }

  get player() {
    return this.log.roleComingOut?.player
  }

  get showsCutin() {
    return this.shows && this.showsSelfProclaim(this.log)
  }

  showsSelfProclaim(log: CutinLog) {
    if (!log.selfProclaimNotice) {
      return true
    }

    if (!this.playerSelfRoleId) {
      return true
    }

    const logRoleId = log.selfProclaimNotice?.player.roleId

    if (!logRoleId) {
      return false
    }

    if (this.isMafia(logRoleId) && this.isMafia(this.playerSelfRoleId)) {
      return true
    }

    if (this.isBelievers(logRoleId) && this.isBelievers(this.playerSelfRoleId)) {
      return true
    }

    return false
  }

  isMafia(roleId: RoleId) {
    return roleId === RoleId.mafia || roleId === RoleId.godfather
  }

  isBelievers(roleId: RoleId) {
    return roleId === RoleId.believers
  }
}
